import { createSlice } from '@reduxjs/toolkit';
import { get } from 'api/fetch';
// ================== Reducers ================== //

const slice = createSlice({
  name: 'ambassadorUser',
  initialState: {
    isLoading: false,
    error: null,
    ambassadorUserDetails: null
  },
  reducers: {
    fetchAmbassador: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchAmbassadorSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.ambassadorUserDetails = { ...payload };
    },
    fetchAmbassadorFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const fetchAmbassador = (redirectOnUnauthorized) => async (dispatch) => {
  try {
    const response = await get('/affiliate', {
      redirectOnUnauthorized
    });
    dispatch(actions.fetchAmbassadorSuccess(response));
  } catch (error) {
    dispatch(actions.fetchAmbassadorFailure(error));
  }
};

export const clearError = () => (dispatch) => {
  dispatch(actions.clearError());
};
